import { z } from 'zod';
/**
 * Delete Process Request Schema
 * DELETE /api/v2/process/:id
 */ export const DeleteProcessRequestSchema = z.object({});
/**
 * Delete Process Response Schema
 * DELETE /api/v2/process/:id
 */ export const DeleteProcessResponseSchema = z.object({
    success: z.boolean()
});

//# sourceMappingURL=delete-process.schema.js.map